var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo"},[_c('div',{staticClass:"game-controls"},[_c('Time',{on:{"timeFinished":function($event){return _vm.$emit('next-round')}}}),_c('Rounds')],1),_c('PravoTop',{attrs:{"Image":"gameOverview","Header":this.gameName}}),_c('div',{staticClass:"charts"},[_c('SelectConfiguration')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }